var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowestPrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7 7.125L7.125 10.7C7.025 10.8 6.9125 10.875 6.7875 10.925C6.6625 10.975 6.5375 11 6.4125 11C6.2875 11 6.1625 10.975 6.0375 10.925C5.9125 10.875 5.8 10.8 5.7 10.7L1.2875 6.2875C1.19583 6.19583 1.125 6.08958 1.075 5.96875C1.025 5.84792 1 5.72083 1 5.5875V2C1 1.725 1.09792 1.48958 1.29375 1.29375C1.48958 1.09792 1.725 1 2 1H5.5875C5.72083 1 5.85 1.02708 5.975 1.08125C6.1 1.13542 6.20833 1.20833 6.3 1.3L10.7 5.7125C10.8 5.8125 10.8729 5.925 10.9188 6.05C10.9646 6.175 10.9875 6.3 10.9875 6.425C10.9875 6.55 10.9646 6.67292 10.9188 6.79375C10.8729 6.91458 10.8 7.025 10.7 7.125ZM6.4125 10L9.9875 6.425L5.575 2H2V5.575L6.4125 10ZM3.25 4C3.45833 4 3.63542 3.92708 3.78125 3.78125C3.92708 3.63542 4 3.45833 4 3.25C4 3.04167 3.92708 2.86458 3.78125 2.71875C3.63542 2.57292 3.45833 2.5 3.25 2.5C3.04167 2.5 2.86458 2.57292 2.71875 2.71875C2.57292 2.86458 2.5 3.04167 2.5 3.25C2.5 3.45833 2.57292 3.63542 2.71875 3.78125C2.86458 3.92708 3.04167 4 3.25 4Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowestPrice);
export default __webpack_public_path__ + "static/media/lowest_price.0a250c857df99c6adbd3092fdab603c3.svg";
export { ForwardRef as ReactComponent };